// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fXus_I9vYVaQwnHmype1 {
  position: relative;
  flex-shrink: 0;
  width: 360px;
}
@media only screen and (max-width: 767px) {
  .fXus_I9vYVaQwnHmype1 {
    position: absolute;
    left: 0;
    right: 0;
    top: 80px;
    width: 100%;
    padding: 12px 16px;
    background: #FFFFFF;
    box-shadow: 0 8px 12px rgba(17, 19, 21, 0.05);
  }
  .dark-mode .fXus_I9vYVaQwnHmype1 {
    background: #111315;
  }
}
.fXus_I9vYVaQwnHmype1.WnlQsGAefnzz1G38aAwh .D4XrlIuDk3wvlxOUYqpN,
.fXus_I9vYVaQwnHmype1.WnlQsGAefnzz1G38aAwh ._itCMsZagiFQekp2L5nb {
  visibility: hidden;
  opacity: 0;
}
.fXus_I9vYVaQwnHmype1.WnlQsGAefnzz1G38aAwh .luXlonFjMdpqiDIng8gx,
.fXus_I9vYVaQwnHmype1.WnlQsGAefnzz1G38aAwh .SyIDaYqlwhR9_R4tx8Ue {
  visibility: visible;
  opacity: 1;
}
.fXus_I9vYVaQwnHmype1.WnlQsGAefnzz1G38aAwh .tPUdoFcuEmNG4tu1GycH {
  visibility: visible;
  opacity: 1;
}

.KxFNbfOgzXMXhDCAC30y {
  position: relative;
  z-index: 2;
}

.D4XrlIuDk3wvlxOUYqpN,
.luXlonFjMdpqiDIng8gx,
._itCMsZagiFQekp2L5nb,
.SyIDaYqlwhR9_R4tx8Ue {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s;
}
.D4XrlIuDk3wvlxOUYqpN svg,
.luXlonFjMdpqiDIng8gx svg,
._itCMsZagiFQekp2L5nb svg,
.SyIDaYqlwhR9_R4tx8Ue svg {
  transition: fill 0.2s;
}

.D4XrlIuDk3wvlxOUYqpN {
  left: 12px;
}
.D4XrlIuDk3wvlxOUYqpN svg {
  fill: #6F767E;
}
.D4XrlIuDk3wvlxOUYqpN:hover svg {
  fill: #1A1D1F;
}

._itCMsZagiFQekp2L5nb {
  right: 8px;
  width: 56px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.05), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
  font-size: 16px;
  font-weight: 600;
  color: #1A1D1F;
}
.dark-mode ._itCMsZagiFQekp2L5nb {
  background: #1A1D1F;
  box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.05), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 1px 0px rgba(255, 255, 255, 0.08);
  color: #FCFCFC;
}

@media only screen and (max-width: 767px) {
  ._itCMsZagiFQekp2L5nb {
    display: none;
  }
}
._itCMsZagiFQekp2L5nb:hover {
  color: #2A85FF;
}

.luXlonFjMdpqiDIng8gx {
  left: 10px;
}
.luXlonFjMdpqiDIng8gx svg {
  fill: #2A85FF;
}
.luXlonFjMdpqiDIng8gx:hover {
  transform: translate(-2px, -50%);
}

.SyIDaYqlwhR9_R4tx8Ue {
  right: 10px;
  width: 32px;
  height: 32px;
}
.SyIDaYqlwhR9_R4tx8Ue svg {
  fill: #9A9FA5;
}
.SyIDaYqlwhR9_R4tx8Ue:hover svg {
  fill: #FF6A55;
}

.luXlonFjMdpqiDIng8gx,
.SyIDaYqlwhR9_R4tx8Ue {
  visibility: hidden;
  opacity: 0;
}

.FaWsaWafwBOlF22_OFwD {
  width: 100%;
  height: 48px;
  padding: 0 68px 0 42px;
  background: #F4F4F4;
  border: 2px solid transparent;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #1A1D1F;
  transition: all 0.2s;
}
.dark-mode .FaWsaWafwBOlF22_OFwD {
  background: #272B30;
  color: #FCFCFC;
}

.FaWsaWafwBOlF22_OFwD::placeholder {
  color: #9A9FA5;
}
.FaWsaWafwBOlF22_OFwD:focus {
  border-color: #2A85FF;
  background: #FFFFFF;
}
.dark-mode .FaWsaWafwBOlF22_OFwD:focus {
  background: #111315;
}

.tPUdoFcuEmNG4tu1GycH {
  position: absolute;
  top: -12px;
  left: -12px;
  right: -12px;
  padding: 84px 12px 12px;
  border: 1px solid transparent;
  box-shadow: 0px 0px 14px -4px rgba(0, 0, 0, 0.05), 0px 32px 48px -8px rgba(0, 0, 0, 0.1);
  background: #FFFFFF;
  border-radius: 16px;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .tPUdoFcuEmNG4tu1GycH {
    top: 100%;
    left: 0;
    right: 0;
    max-height: calc(100vh - 152px);
    padding: 16px 8px;
    border-radius: 0;
    border-top: 1px solid #EFEFEF;
    box-shadow: 0 12px 32px rgba(17, 19, 21, 0.05);
    overflow: auto;
  }
}
.dark-mode .tPUdoFcuEmNG4tu1GycH {
  background: #1A1D1F;
  border-color: #272B30;
}

.ZjN8AKUnD1abPefICF_V:not(:last-child) {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #EFEFEF;
}
.dark-mode .ZjN8AKUnD1abPefICF_V:not(:last-child) {
  border-color: #272B30;
}

@media only screen and (max-width: 767px) {
  .ZjN8AKUnD1abPefICF_V:not(:last-child) {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
}

.pLoGIviz1W1j6qr2CX9L {
  margin-bottom: 12px;
  padding-left: 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Search/Search.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;AADJ;ACYI;EDdJ;IAKQ,kBAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,kBAAA;IACA,mBC2BJ;ID1BI,6CAAA;EACN;EC6KW;ID5KD,mBCgCP;ED9BH;AACF;AADQ;;EAEI,kBAAA;EACA,UAAA;AAGZ;AAFQ;;EAEI,mBAAA;EACA,UAAA;AAIZ;AAHQ;EACI,mBAAA;EACA,UAAA;AAKZ;;AAHA;EACI,kBAAA;EACA,UAAA;AAMJ;;AAJA;;;;EAII,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AAOJ;AANI;;;;EACI,qBAAA;AAWR;;AATA;EACI,UAAA;AAYJ;AAXI;EACI,aCJH;ADiBL;AAXQ;EACI,aCJP;ADiBL;;AAXA;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBCjBA;EDkBA,kBAAA;EACA,uIAAA;EACA,eAAA;EACA,gBAAA;EACA,cCfC;AD6BL;ACgHa;ED5HL,mBCjBH;EDkBG,uIAAA;EACA,cCzBH;ADwCL;;ACjEI;EDqCJ;IAeQ,aAAA;EAkBN;AACF;AAlBI;EACI,cCxCH;AD4DL;;AAlBA;EACI,UAAA;AAqBJ;AApBI;EACI,aC7CH;ADmEL;AArBI;EACI,gCAAA;AAuBR;;AArBA;EACI,WAAA;EACA,WAAA;EACA,YAAA;AAwBJ;AAvBI;EACI,aClCE;AD2DV;AAvBQ;EACI,aCvDP;ADgFL;;AAvBA;;EAEI,kBAAA;EACA,UAAA;AA0BJ;;AAxBA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBCxDC;EDyDD,6BAAA;EACA,mBAAA;ECtBA,eAAA;EACA,gBAAA;EACA,gBAAA;EDsBA,cCvDC;EDwDD,oBAAA;AA6BJ;ACwDa;EDnFL,mBC3DH;ED4DG,cCjEH;AD+FL;;AA7BI;EACI,cC1DE;AD0FV;AA/BI;EACI,qBChFH;EDiFG,mBCvEJ;ADwGJ;AC4Ca;ED3ED,mBCjEP;ADmGL;;AAhCA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EACA,wFAAA;EACA,mBCnFA;EDoFA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAmCJ;AClJI;EDmGJ;IAcQ,SAAA;IACA,OAAA;IACA,QAAA;IACA,+BAAA;IACA,iBAAA;IACA,gBAAA;IACA,6BAAA;IACA,8CAAA;IACA,cAAA;EAqCN;AACF;ACaa;EDjDL,mBC5FH;ED6FG,qBC9FH;ADqIL;;AAnCI;EACI,mBAAA;EACA,oBAAA;EACA,gCAAA;AAsCR;ACGa;EDvCD,qBCvGP;AD8IL;;AC5KI;EDgIA;IAOQ,mBAAA;IACA,oBAAA;EA0CV;AACF;;AAzCA;EACI,mBAAA;EACA,kBAAA;EC9CA,eAAA;EACA,gBAAA;EACA,yBAAA;ED8CA,cClHC;ADgKL","sourcesContent":["@import ../../../styles/helpers\n\n.search\n    position: relative\n    flex-shrink: 0\n    width: 360px\n    +m\n        position: absolute\n        left: 0\n        right: 0\n        top: 80px\n        width: 100%\n        padding: 12px 16px\n        background: $n\n        box-shadow: 0 8px 12px rgba($n8, .05)\n        +dark\n            background: $n8\n    &.active\n        .start,\n        .result\n            visibility: hidden\n            opacity: 0\n        .direction,\n        .close\n            visibility: visible\n            opacity: 1\n        .body\n            visibility: visible\n            opacity: 1\n\n.head\n    position: relative\n    z-index: 2\n\n.start,\n.direction,\n.result,\n.close\n    position: absolute\n    top: 50%\n    transform: translateY(-50%)\n    transition: all .2s\n    svg\n        transition: fill .2s\n\n.start\n    left: 12px\n    svg\n        fill: $n4\n    &:hover\n        svg\n            fill: $n7\n\n.result\n    right: 8px\n    width: 56px\n    height: 32px\n    background: $n\n    border-radius: 8px\n    box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.05), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25)\n    font-size: 16px\n    font-weight: 600\n    color: $n7\n    +dark\n        background: $n7\n        box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.05), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 1px 0px rgba(255, 255, 255, 0.08)\n        color: $n1\n    +m\n        display: none\n    &:hover\n        color: $p1\n\n.direction\n    left: 10px\n    svg\n        fill: $p1\n    &:hover\n        transform: translate(-2px,-50%)\n\n.close\n    right: 10px\n    width: 32px\n    height: 32px\n    svg\n        fill: $shades1\n    &:hover\n        svg\n            fill: $p3\n\n.direction,\n.close\n    visibility: hidden\n    opacity: 0\n\n.input\n    width: 100%\n    height: 48px\n    padding: 0 68px 0 42px\n    background: $n2\n    border: 2px solid transparent\n    border-radius: 12px\n    +base1-s\n    color: $n7\n    transition: all .2s\n    +dark\n        background: $n6\n        color: $n1\n    &::placeholder\n        color: $shades1\n    &:focus\n        border-color: $p1\n        background: $n\n        +dark\n            background: $n8\n\n.body\n    position: absolute\n    top: -12px\n    left: -12px\n    right: -12px\n    padding: 84px 12px 12px\n    border: 1px solid transparent\n    box-shadow: 0px 0px 14px -4px rgba(0, 0, 0, 0.05), 0px 32px 48px -8px rgba(0, 0, 0, 0.1)\n    background: $n\n    border-radius: 16px\n    visibility: hidden\n    opacity: 0\n    transition: all .2s\n    +m\n        top: 100%\n        left: 0\n        right: 0\n        max-height: calc(100vh - 152px)\n        padding: 16px 8px\n        border-radius: 0\n        border-top: 1px solid $n3\n        box-shadow: 0 12px 32px rgba($n8, .05)\n        overflow: auto\n    +dark\n        background: $n7\n        border-color: $n6\n        \n\n.box\n    &:not(:last-child)\n        margin-bottom: 24px\n        padding-bottom: 24px\n        border-bottom: 1px solid $n3\n        +dark\n            border-color: $n6\n        +m\n            margin-bottom: 16px\n            padding-bottom: 16px\n\n.category\n    margin-bottom: 12px\n    padding-left: 12px\n    +caption1\n    color: $n4","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `fXus_I9vYVaQwnHmype1`,
	"active": `WnlQsGAefnzz1G38aAwh`,
	"start": `D4XrlIuDk3wvlxOUYqpN`,
	"result": `_itCMsZagiFQekp2L5nb`,
	"direction": `luXlonFjMdpqiDIng8gx`,
	"close": `SyIDaYqlwhR9_R4tx8Ue`,
	"body": `tPUdoFcuEmNG4tu1GycH`,
	"head": `KxFNbfOgzXMXhDCAC30y`,
	"input": `FaWsaWafwBOlF22_OFwD`,
	"box": `ZjN8AKUnD1abPefICF_V`,
	"category": `pLoGIviz1W1j6qr2CX9L`
};
export default ___CSS_LOADER_EXPORT___;
